import { ConstraintMinMaxRigsPerAreaBase } from './base/constraint-min-max-rigs-per-area-base';

export class ConstraintMinMaxRigsPerArea extends ConstraintMinMaxRigsPerAreaBase { }